module.exports = __webpack_public_path__ + "img/aperturaPuertas.12506282.svg";